import "../../App.css";
import React, { Suspense, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Loading from "../../Component/Loading";
import {
  HrOperationEmpPanelSidebarData,
  HrOperationPanelSidebarData,
} from "../../Module/hrOperationPanelSidebarData";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { useDispatch } from "react-redux";
import { Logout, setInitialState } from "../../Action/authAction";
import { showSuccessSnackbar } from "../../Action/snackbarAction";

// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
function HrOperationDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "HROPERATIONS" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2
            ? HrOperationEmpPanelSidebarData
            : HrOperationPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <CommonRoutes loginType={loginType} defaultPage={""}>
            <Route path="/" />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}

export default HrOperationDashboard;
